@if (user; as user) {
  <div class="row ap-my-spacing-7">
    <div class="col-12">
      <div class="d-flex justify-content-end gap-1">
        <ap-button
          [btnType]="'text'"
          [icon]="'view-outline'"
          [label]="'Preview'"
          (onClick)="preview()"
        ></ap-button>
        <ap-button
          [btnType]="'tertiary'"
          [icon]="'document-download-outline'"
          [label]="'Download'"
          [loading]="true"
          [isLoading]="isDownloading"
          (onClick)="download()"
        ></ap-button>
      </div>
      @if (user.isPwC) {
        <app-video-team-form></app-video-team-form>
      }
      @if (!user.isPwC) {
        <app-vendors-form class="col-12"></app-vendors-form>
      }
    </div>
  </div>
}
